var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageHeroPressBenzinga(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 127 18",
    width: 127,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.045898.357422h126.954v17.2849h-126.954z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.3012 17.5615h12.1885v-3.2089h-8.4942v-3.937h7.038v-3.20892h-7.038v-3.64035h8.5481v-3.208908h-12.2424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.1588 11.1976-7.9819-10.840178h-5.5009l1.7258 2.184208v15.10077h3.6673v-11.32559l8.2514 11.24469h3.5325v-17.204078h-3.6942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7465 8.71675c1.6179-.29662 2.9662-1.80669 2.9662-3.93697 0-2.29208-1.6719-4.422358-4.9886-4.422358h-10.6783847l1.6718647 2.130278v15.1007h9.38402c3.3168 0 5.0426-2.0763 5.0426-4.665-.0809-2.1303-1.5371-3.96396-3.3977-4.20665zm-7.3616-5.12346h4.61111c1.24039 0 2.02239.72807 2.02239 1.8067 0 1.07862-.782 1.80669-2.02239 1.80669h-4.61111zm4.7729 10.78621h-4.7729v-3.9639h4.7729c1.4022 0 2.1842.8898 2.1842 1.9685 0 1.2404-.8359 1.9685-2.1842 1.9954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.73 11.1976h1.914v2.0224c-.997.809-2.238 1.2674-3.532 1.2944-3.0742 0-5.2315-2.3461-5.2315-5.50103 0-3.15497 2.1843-5.50098 5.2315-5.50098 1.591 0 3.074.83594 3.937 2.18422l2.912-1.61794c-1.24-1.96849-3.424-3.721248-6.876-3.721248-4.8809 0-8.9257 3.370698-8.9257 8.602018 0 5.23136 3.9909 8.60206 8.9257 8.60206 2.696.0539 5.258-1.1056 7.038-3.1011v-6.36386h-7.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.1468 11.1976-8.0088-10.840178h-5.474l1.6988 2.184208v15.10077h3.6943v-11.32559l8.2515 11.24469h3.5055v-17.204078h-3.6673z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.312.357422h-7.092l1.699 2.184208-.297.83594-5.501 14.26483h4.153l1.078-2.9123h7.416l1.079 2.9123h4.152zm-5.016 11.109778 2.697-7.41549 2.696 7.41549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.5336.357422h-3.6943v17.284978h3.6943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.9004 3.32364v-2.966218h-12.9705v3.208908h8.1436l-8.1436 11.05587v2.9393h13.1053v-3.2089h-8.3324z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHeroPressBenzinga);
export default __webpack_public_path__ + "static/media/imageHeroPressBenzinga.8777b34fab78001b6508740f62a7f2c0.svg";
export { ForwardRef as ReactComponent };